<!-- =========================================================================================
    File Name: ContraAddNew.vue
    Description: Add new Contra
    ----------------------------------------------------------------------------------------
    Item Name: Vaagai Tecknowledge - Easy Admin
    Author: Web Team
    Author URL: http://www.vaagai.org.in/
========================================================================================== -->


<template>
    <div class="px-6 pb-2 pt-6">
        <form @submit.prevent="submitForm">
            <div class="vx-row">

                <div class="vx-col sm:w-1/3 w-full mb-3">
                    <span class="text-primary text-sm vs-placeholder-label"> Date </span>
                    <datepicker placeholder="Invoice Date" v-model="TransactionDate" :format="DateFormat" v-validate="'required'" ></datepicker>
                    <span class="text-danger text-sm" v-show="errors.has('TransactionDate')">{{ errors.first('TransactionDate') }}</span>
                </div>
                
                <div class="vx-col sm:w-1/3 w-full mb-3">
                    <span class="text-primary text-sm vs-placeholder-label"> From Ledger Category </span>
                    <v-select v-model="FromLedgerCategoryId" name="FromLedgerCategoryId" :value="FromLedgerCategoryId" :options="FromLedgerCategoryIdOptions" label="text" :reduce="option => option.value" class="w-full" v-validate="'required|numeric'" > </v-select>
                    <span class="text-danger text-sm" v-show="errors.has('FromLedgerCategoryId')">{{ errors.first('FromLedgerCategoryId') }}</span>
                </div>

                <div class="vx-col sm:w-1/3 w-full mb-3">
                    <span class="text-primary text-sm vs-placeholder-label"> From Ledger Name </span>
                    <v-select v-model="FromLedgerId" name="FromLedgerId" :value="FromLedgerId" :options="FromLedgerIdOptions" label="text" :reduce="option => option.value" class="w-full" v-validate="'required|numeric'" > </v-select>
                    <span class="text-danger text-sm" v-show="errors.has('FromLedgerId')">{{ errors.first('FromLedgerId') }}</span>
                </div>

            </div>

            <div class="vx-row">
                
                <div class="vx-col sm:w-1/3 w-full mb-3">
                    <span class="text-primary text-sm vs-placeholder-label"> Ledger Details </span>
                    <p>{{ LedgerDetails }}</p>
                </div>

                <div class="vx-col sm:w-1/3 w-full mb-3">
                    <span class="text-primary text-sm vs-placeholder-label"> Closing Balance </span>
                    <p v-html="LedgerClosingBalance"></p>
                </div>

                <div class="vx-col sm:w-1/3 w-full mb-3">
                    <span class="text-primary text-sm vs-placeholder-label"> Taxable </span>
                        <v-select v-model="TaxableId" name="TaxableId" :value="TaxableId" :options="TaxableIdOptions" label="text" :reduce="option => option.value" class="w-full" v-validate="'required|numeric'" > </v-select>
                        <span class="text-danger text-sm" v-show="errors.has('TaxableId')">{{ errors.first('TaxableId') }}</span>
                </div>                    
            </div>

            <div class="vx-row">
                <div class="vx-col sm:w-1/3 w-full mb-3">
                    <vs-input class="w-full" label-placeholder="Amount" v-model="Amount" v-validate="'required'" name="Amount" />
                    <span class="text-danger text-sm" v-show="errors.has('Amount')">{{ errors.first('Amount') }}</span>
                </div>

                <div class="vx-col sm:w-1/3 w-full mb-3">
                    <span class="text-primary text-sm vs-placeholder-label"> To Ledger Category </span>
                    <v-select v-model="ToLedgerCategoryId" name="ToLedgerCategoryId" :value="ToLedgerCategoryId" :options="ToLedgerCategoryIdOptions" label="text" :reduce="option => option.value" class="w-full" v-validate="'required|numeric'" > </v-select>
                    <span class="text-danger text-sm" v-show="errors.has('PaymentType')">{{ errors.first('PaymentType') }}</span>
                </div>

                <div class="vx-col sm:w-1/3 w-full mb-3">
                    <span class="text-primary text-sm vs-placeholder-label"> To Ledger Name </span>
                    <v-select v-model="ToLedgerId" name="ToLedgerId" :value="ToLedgerId" :options="ToLedgerIdOptions" label="text" :reduce="option => option.value" class="w-full" v-validate="'required|numeric'" > </v-select>
                    <span class="text-danger text-sm" v-show="errors.has('PaymentMode')">{{ errors.first('PaymentMode') }}</span>
                </div>
            </div>

            <div class="vx-row">
                <div class="vx-col w-full mb-3">
                    <vs-input class="w-full" label-placeholder="Description" v-model="Description" v-validate="'required'" name="Description" />
                    <span class="text-danger text-sm" v-show="errors.has('Description')">{{ errors.first('Description') }}</span>
                </div>
            </div>

            <div class="vx-row">
                <div class="vx-col w-full text-right mb-3">
                    <vs-button type="filled" @click.prevent="submitForm" class="mr-3 mb-2"> {{ $t("SubmitButton") }} </vs-button>
                    <vs-button color="warning" type="border" class="mb-2" @click.prevent="closePrompt" > {{ $t("CancelButton") }} </vs-button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>

import companyConfig from '@/company_config.json'
import common from '@/views/Common.vue'
import { Validator } from 'vee-validate';
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';

const dict = {    
    custom: {        
        ProductGroupName: { required : 'Product Group should not be empty', },
    }
};

// register custom messages
Validator.localize('en', dict);

export default {
    mixins: [common],
    components: {
        'v-select': vSelect,
        Datepicker
    },
    props: {
        addRecordPrompt: {
            type: Boolean,
            required: true,
        },
    },    
    data() {
        return {
            // activePrompt: false,

            TransactionType : 5,
            TaxableId : '',
            TransactionDate : '',
            FromLedgerCategoryId : '',
            FromLedgerId : '',
            LedgerDetails : '',
            Amount : '',
            ToLedgerCategoryId : '',
            ToLedgerId : '',
            Description : '',

            LedgerClosingBalance: '',
            DateFormat: "d-MMM-yyyy",
            TaxableIdOptions : this.selectListTrueFalse(),
            FromLedgerCategoryIdOptions : [],
            FromLedgerIdOptions: [],
            ToLedgerCategoryIdOptions: [],
            ToLedgerIdOptions: [],

        }
    },
    computed: {
        dataArrayLength() {
            return this.$store.getters['allTransaction/dataArrayLength'];
        },
        allLedgers(){
            return this.$store.getters['ledger/dataList'];
        },
    },
    methods: {
        closePrompt() {
            console.log('closePrompt called');
            this.$emit('hideAddRecordPrompt');
        },
        addRecordDetails() {
            // add todo in store and clear all fields in dialog

            var fromLedger=this.FromLedgerId;
            var toLedger=this.ToLedgerId;

            if (fromLedger != toLedger) {
                var recordObj = {
                    "TransactionType" :  this.TransactionType, 
                    "TaxableId" :  this.TaxableId, 
                    "TransactionDate" :  this.TransactionDate, 
                    "FromLedgerCategoryId" :  this.FromLedgerCategoryId, 
                    "FromLedgerId" :  this.FromLedgerId, 
                    "Amount" :  this.Amount, 
                    "ToLedgerCategoryId" :  this.ToLedgerCategoryId, 
                    "ToLedgerId" :  this.ToLedgerId, 
                    "Description" :  this.Description, 
                };

                var server_url=companyConfig.apiURL;
                var record = {};
                record.token=this.$session.get('token');
                record.add_url=server_url+'lib/api/transaction/transaction/others_create';
                record.form=recordObj;
                record.list_url=server_url+'lib/api/transaction/transaction/lists';
                record.list_where={
                    "transaction_type" : "0"
                };
                console.log('record='+JSON.stringify(record));
                record.loading=this.$vs.loading;
                record.notify=this.$vs.notify;
                record.http=this.$http;            
                this.$store.dispatch('allTransaction/addRecordDetails', record);

                this.closePrompt();                
            }else{
                var message="From Ledger and To Ledger should not be same";
                this.errorMessage(message);
            }

        },
        clearFields() {
            // clear all fileds in todo
            this.TaxableId =  '';
            this.TransactionDate =  '';
            this.FromLedgerCategoryId =  '';
            this.FromLedgerId =  '';
            this.LedgerDetails = '';
            this.LedgerClosingBalance = '';            
            this.Amount =  '';
            this.ToLedgerCategoryId =  '';
            this.ToLedgerId =  '';
            this.Description =  '';

            this.$parent.addRecordPrompt = false;
        },
        submitForm() {
            this.$validator.validateAll().then(result => {
                if (result) this.addRecordDetails();
            })
        },
        checkLedgerDetails() {
            console.log('checkLedgerDetails called');
            var temp_code=this.FromLedgerId;            
            console.log('temp_code='+temp_code);
            console.log('allLedgers='+JSON.stringify(this.allLedgers));
            var idx = this.allLedgers.map(e => e.LedgerId).indexOf(temp_code);
            console.log('idx='+idx);
            if (idx >= 0) {
                console.log('ledger='+JSON.stringify(this.allLedgers[idx]));
                var Description=this.allLedgers[idx]['Description'];
                var ClosingBalanceWith=this.allLedgers[idx]['ClosingBalanceWith'];
                var ClosingBalanceWithout=this.allLedgers[idx]['ClosingBalanceWithout'];
                var ClosingBalance=this.allLedgers[idx]['ClosingBalance'];
                var LedgerClosingBalance = 'With = '+ClosingBalanceWith+'<br /> Without = '+ClosingBalanceWithout+'<br /> Overall = '+ClosingBalance+'';
                console.log('Description='+Description+', LedgerClosingBalance='+LedgerClosingBalance);

                this.LedgerDetails = Description;
                this.LedgerClosingBalance = LedgerClosingBalance;
                
            }else{
                // var message='Customer details not found';
                // this.errorMessage(message);
                this.LedgerDetails = '';
                this.LedgerClosingBalance = '';
            }
            
        },        
    },
    beforeMount() {
        if (!this.$session.exists()) {
            console.log('your session is expired');
            this.$router.push('/');      
        }else{

            const token=this.$session.get('token');
            const username=this.$session.get('username');
            const role=this.$session.get('role');
            const CompanyId=this.$session.get('CompanyId');
            const CompanyStateId=this.$session.get('CompanyStateId');
            console.log('token='+token+', username='+username+', role='+role+', CompanyId='+CompanyId+', CompanyStateId='+CompanyStateId);

            this.CompanyId = CompanyId;
            this.CompanyStateId = CompanyStateId;

            var server_url=companyConfig.apiURL;

            // Load Ledgers

            var getAllRecords={};
            getAllRecords.token=this.$session.get('token');
            getAllRecords.list_url=server_url+'lib/api/ledgers/ledger/ledger/lists';
            getAllRecords.list_where={
                "LedgerGroup": "",
                "where": {
                    "ledger_details_ledger_category_id >=" : 1
                },                
            };
            console.log('beforeMount getAllRecords='+JSON.stringify(getAllRecords));
            getAllRecords.loading=this.$vs.loading;
            getAllRecords.notify=this.$vs.notify;
            getAllRecords.http=this.$http;
            this.$store.dispatch('ledger/loadAllRecords', getAllRecords);

            // From Ledger Category Dropdown

            var selectbox1_source = 'FromLedgerCategoryId'
            var selectbox1_destination = 'FromLedgerCategoryIdOptions'
            var selectbox1_url = 'lib/api/data/get_transaction_ledger_category_options'
            // Ledger Category 4=Bank, 5=Cash, 15=Payment Wallet
            var selectbox1_conditions_array = {
                'TransactionType':5,
                'LedgerType':1,
                'where': {}
            }
            this.getSelectBoxOptions(selectbox1_source, selectbox1_destination, selectbox1_conditions_array, selectbox1_url)

            // To Ledger Category Dropdown

            var selectbox2_source = 'ToLedgerCategoryId'
            var selectbox2_destination = 'ToLedgerCategoryIdOptions'
            var selectbox2_url = 'lib/api/data/get_transaction_ledger_category_options'
            // Ledger Category 4=Bank, 5=Cash, 15=Payment Wallet
            var selectbox2_conditions_array = {
                'TransactionType':5,
                'LedgerType':1,
                'where': {}
            }
            this.getSelectBoxOptions(selectbox2_source, selectbox2_destination, selectbox2_conditions_array, selectbox2_url)

        }
    },
    watch: {
        FromLedgerIdOptions: function(){
            console.log('watch FromLedgerIdOptions='+JSON.stringify(this.FromLedgerIdOptions));
            var n1=this.FromLedgerIdOptions.length;
            console.log('n1='+n1);
            if (n1 > 0) {
                var temp=this.FromLedgerIdOptions[0];
                console.log('temp='+JSON.stringify(temp));
                var str1=this.FromLedgerId;                
                var str2=str1.toString();
                var index = this.FromLedgerIdOptions.map(e => e.value).indexOf(str1);
                console.log('str1='+str1+', str2='+str2+', index='+index);
                this.FromLedgerId=index > 0 ? str2 : "";
            }
        },
        FromLedgerCategoryId: function () {
            var temp=this.FromLedgerCategoryId;
            console.log('watch FromLedgerCategoryId='+temp);
            if (temp != "") {
                var selectbox1_source = 'FromLedgerId'
                var selectbox1_destination = 'FromLedgerIdOptions'
                var selectbox1_url = 'lib/api/data/get_ledger_options'
                var selectbox1_conditions_array = {
                    'ledger_details_ledger_category_id': temp,
                }
                this.getSelectBoxOptions(selectbox1_source, selectbox1_destination, selectbox1_conditions_array, selectbox1_url);
            }
        },
        FromLedgerId: function(){
            var temp=this.FromLedgerId;
            console.log('watch FromLedgerId='+temp);
            
            if (temp != "") {
                this.checkLedgerDetails();
            }
            
        },
        ToLedgerCategoryId: function(){
            var temp=this.ToLedgerCategoryId;
            console.log('watch ToLedgerCategoryId='+temp);
            if (temp != "") {
                var selectbox1_source = 'ToLedgerId'
                var selectbox1_destination = 'ToLedgerIdOptions'
                var selectbox1_url = 'lib/api/data/get_ledger_options'
                var selectbox1_conditions_array = {
                    'ledger_details_ledger_category_id': temp,
                }
                this.getSelectBoxOptions(selectbox1_source, selectbox1_destination, selectbox1_conditions_array, selectbox1_url);
            }
        },
        ToLedgerIdOptions: function(){
            console.log('watch ToLedgerIdOptions='+JSON.stringify(this.ToLedgerIdOptions));
            var n1=this.ToLedgerIdOptions.length;
            console.log('n1='+n1);
            if (n1 > 0) {
                var temp=this.ToLedgerIdOptions[0];
                console.log('temp='+JSON.stringify(temp));
                var str1=this.ToLedgerId;
                var str2=str1.toString();
                var index = this.ToLedgerIdOptions.map(e => e.value).indexOf(str1);
                console.log('str1='+str1+', str2='+str2+', index='+index);
                this.ToLedgerId=index > 0 ? str2 : "";
            }
        },
    },
}
</script>
<style>
  .con-vs-popup .vs-popup {
    width: 800px;
  }
</style>